import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Scale } from 'lucide-react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_140853a5-d37e-4724-8f64-c2f7eabb8728/artifacts/4msp2ofk_agrosvetlogo.png';

const KVKKPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#F8F8FC]" data-testid="kvkk-page">
      {/* Header */}
      <header className="sticky top-0 z-30 bg-white/80 backdrop-blur-xl border-b border-gray-100">
        <div className="max-w-3xl mx-auto flex items-center gap-3 px-4 py-3">
          <button onClick={() => navigate('/')} className="p-2 rounded-xl hover:bg-gray-100 transition-colors" data-testid="kvkk-back-btn">
            <ArrowLeft size={20} className="text-gray-600" />
          </button>
          <img src={LOGO_URL} alt="AGROSVET" className="w-7 h-7 object-contain" />
          <span className="font-bold text-gray-900 text-sm">AGROSVET</span>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-4 py-8 sm:py-12">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-10 h-10 rounded-2xl bg-[#6b6de3]/10 flex items-center justify-center">
            <Scale size={20} className="text-[#6b6de3]" />
          </div>
          <div>
            <h1 className="text-2xl sm:text-3xl font-extrabold text-gray-900">KVKK Aydınlatma Metni</h1>
            <p className="text-sm text-[#8E8E93] mt-0.5">Yürürlük: 23 Mart 2026</p>
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 sm:p-8 space-y-8" data-testid="kvkk-content">
          {/* Veri Sorumlusu Info */}
          <div className="p-4 bg-[#F2F2F7] rounded-xl space-y-1.5">
            <h3 className="font-bold text-gray-900 text-sm">Veri Sorumlusu</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-1 text-sm text-gray-600">
              <p><span className="font-medium text-gray-700">Ad:</span> Onur Ertaş</p>
              <p><span className="font-medium text-gray-700">VKN:</span> 3720635926</p>
              <p className="sm:col-span-2"><span className="font-medium text-gray-700">Adres:</span> Bahçelievler Mh. 3034 Sk. No:5 Isparta / Merkez</p>
              <p><span className="font-medium text-gray-700">Vergi Dairesi:</span> Kaymakkapı</p>
              <p><span className="font-medium text-gray-700">Web:</span> agrosvet.app</p>
              <p><span className="font-medium text-gray-700">E-posta:</span> <a href="mailto:info@agrostech.net" className="text-[#6b6de3] hover:underline">info@agrostech.net</a></p>
            </div>
          </div>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">1. Kişisel Verilerin İşlenme Amacı</h2>
            <p className="text-gray-600 mb-2">Toplanan kişisel veriler:</p>
            <ul className="space-y-1.5 text-gray-600">
              <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 rounded-full bg-[#6b6de3] mt-2 shrink-0" />Veteriner klinik yönetim süreçlerinin yürütülmesi</li>
              <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 rounded-full bg-[#6b6de3] mt-2 shrink-0" />Hasta (pet) kayıtlarının tutulması</li>
              <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 rounded-full bg-[#6b6de3] mt-2 shrink-0" />Müşteri (pet sahibi) iletişiminin sağlanması</li>
              <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 rounded-full bg-[#6b6de3] mt-2 shrink-0" />Hizmet kalitesinin artırılması</li>
              <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 rounded-full bg-[#6b6de3] mt-2 shrink-0" />Yasal yükümlülüklerin yerine getirilmesi</li>
            </ul>
            <p className="text-gray-600 mt-2">amaçlarıyla işlenmektedir.</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">2. İşlenen Kişisel Veriler</h2>
            <ul className="space-y-1.5 text-gray-600">
              <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 rounded-full bg-[#6b6de3] mt-2 shrink-0" />Kimlik bilgileri (ad, soyad)</li>
              <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 rounded-full bg-[#6b6de3] mt-2 shrink-0" />İletişim bilgileri (telefon, e-posta)</li>
              <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 rounded-full bg-[#6b6de3] mt-2 shrink-0" />Pet bilgileri ve sağlık kayıtları</li>
              <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 rounded-full bg-[#6b6de3] mt-2 shrink-0" />İşlem ve kullanım kayıtları</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">3. Kişisel Verilerin Aktarılması</h2>
            <p className="text-gray-600 mb-2">Kişisel veriler:</p>
            <ul className="space-y-1.5 text-gray-600">
              <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 rounded-full bg-[#6b6de3] mt-2 shrink-0" />Yetkili kamu kurum ve kuruluşlarına</li>
              <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 rounded-full bg-[#6b6de3] mt-2 shrink-0" />Hukuki yükümlülükler kapsamında</li>
            </ul>
            <p className="text-gray-600 mt-2">aktarılabilir.</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">4. Veri Toplama Yöntemi ve Hukuki Sebep</h2>
            <p className="text-gray-600 mb-2">Veriler:</p>
            <ul className="space-y-1.5 text-gray-600">
              <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 rounded-full bg-[#6b6de3] mt-2 shrink-0" />AgrosVet platformu üzerinden dijital olarak</li>
              <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 rounded-full bg-[#6b6de3] mt-2 shrink-0" />Kullanıcının açık rızası veya sözleşme kapsamında</li>
            </ul>
            <p className="text-gray-600 mt-3 mb-2">Hukuki sebepler:</p>
            <ul className="space-y-1.5 text-gray-600">
              <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 rounded-full bg-[#6b6de3] mt-2 shrink-0" />KVKK m.5/2 (sözleşmenin kurulması ve ifası)</li>
              <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 rounded-full bg-[#6b6de3] mt-2 shrink-0" />KVKK m.5/2 (hukuki yükümlülüklerin yerine getirilmesi)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">5. KVKK Kapsamındaki Haklarınız</h2>
            <p className="text-gray-600 mb-2">KVKK'nın 11. maddesi uyarınca kullanıcılar:</p>
            <ul className="space-y-1.5 text-gray-600">
              <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 rounded-full bg-[#6b6de3] mt-2 shrink-0" />Kişisel veri işlenip işlenmediğini öğrenme</li>
              <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 rounded-full bg-[#6b6de3] mt-2 shrink-0" />İşlenmişse bilgi talep etme</li>
              <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 rounded-full bg-[#6b6de3] mt-2 shrink-0" />Düzeltme isteme</li>
              <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 rounded-full bg-[#6b6de3] mt-2 shrink-0" />Silinmesini veya yok edilmesini isteme</li>
              <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 rounded-full bg-[#6b6de3] mt-2 shrink-0" />İşlemenin hukuka aykırı olması halinde zararların giderilmesini talep etme</li>
            </ul>
            <p className="text-gray-600 mt-2">haklarına sahiptir.</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">6. Başvuru Yöntemi</h2>
            <p className="text-gray-600 mb-2">KVKK kapsamındaki taleplerinizi:</p>
            <ul className="space-y-1.5 text-gray-600">
              <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 rounded-full bg-[#6b6de3] mt-2 shrink-0" />Yazılı olarak yukarıdaki adrese</li>
              <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 rounded-full bg-[#6b6de3] mt-2 shrink-0" /><a href="mailto:info@agrostech.net" className="text-[#6b6de3] font-medium hover:underline">info@agrostech.net</a> e-posta adresine</li>
            </ul>
            <p className="text-gray-600 mt-2">iletebilirsiniz.</p>
          </section>

          <section className="pt-4 border-t border-gray-100">
            <p className="text-sm text-[#8E8E93]">Bu metin 23 Mart 2026 tarihinde yürürlüğe girmiştir.</p>
          </section>
        </div>
      </main>
    </div>
  );
};

export default KVKKPage;
